<template>
  <div>
    <h2>Constancia de No Adeudo Antimotin</h2>
    <label>
      Nombre del personal:
      <input :value="nombre" readonly />
    </label>
    <label>
      Puesto:
      <input :value="puesto" readonly />
    </label>
    <label>
      Fecha:
      <input :value="fecha" type="date" readonly />
    </label>
    <button @click="generarWord">Generar Word</button>
  </div>
</template>

<script>
import { Packer } from 'docx'
import FormatoNoAdeudoAntimotin from '@/utils/doc-generator/armeria/FormatoNoAdeudoAntimotin'

export default {
  props: {
    nombre: { type: String, required: true },
    puesto: { type: String, required: true },
    fecha: { type: String, required: true },
  },
  methods: {
    async generarWord() {
      const newDoc = await new FormatoNoAdeudoAntimotin({
        nombre: this.nombre,
        puesto: this.puesto,
        fecha: this.fecha,
      }).generate()
      const blob = await Packer.toBlob(newDoc)
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'FormatoNoAdeudoAntimotin.docx'
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
